import { useMutation, useQueryClient } from 'react-query'
import depotsApi from './actions'
import { depotsKeys } from './constants'

const useDepotsMutations = (companyId: number) => {
  const queryClient = useQueryClient()

  const createDepot = useMutation(depotsApi.createDepot, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(depotsKeys.root(companyId))
    },
  })

  const updateDepot = useMutation(depotsApi.updateDepot, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(depotsKeys.depot(companyId))
    },
  })

  return { createDepot, updateDepot }
}

export default useDepotsMutations
